

































































// Vue
import { Component, Vue } from 'vue-property-decorator'

// Components
import { DataTable } from '../../table'
import { IsActive } from '@/components'

// services
import { HolidayService } from '@/services/config'

// Models
import { Paginator } from '@/models'
import { HolidayForm, HolidayModel } from '@/models/config'

@Component({
    name: 'TableListHoliday',
    components: {
        DataTable,
        IsActive
    }
})
export default class TableListHoliday extends Vue {
    loading = false
    items: [HolidayForm] | [] = []
    pagination: Paginator = {
        currentPage: 1,
        total: 0,
        count: 0,
        perPage: 10
    }

    fields = [
        {
            key: 'description',
            sortable: true,
            label: 'Descripción'
        },
        {
            key: 'repeat_yearly',
            sortable: true,
            label: 'Repetir Anualmente',
            formatter: (value: boolean) => {
                return value ? 'SI' : 'NO'
            }
        },
        {
            key: 'date',
            sortable: true,
            label: 'Fecha'
        },
        {
            key: 'status_text',
            sortable: true,
            label: 'Status'
        },
        {
            key: 'actions',
            sortable: false,
            label: '',
            thClass: 'one-line w-30',
            thStyle: {
                width: '15%'
            }
        }
    ]

    created () {
        this.getHolidaysWithPagination()
    }

    changePage (page: number) {
        this.pagination.currentPage = page
        this.getHolidaysWithPagination()
    }

    changePerPage (perPage: number) {
        this.pagination.perPage = perPage
        this.pagination.currentPage = 1
        this.getHolidaysWithPagination()
    }

    async getHolidaysWithPagination () {
        this.loading = true
        const response = await HolidayService.getWithPagination(this.pagination.perPage, this.pagination.currentPage)
        this.items = response.objects
        this.pagination = response.pagination
        this.loading = false
    }

    onlyMonthAndDay (item: HolidayModel) {
        const day = item.day < 10 ? '0' + item.day : item.day
        const month = item.month < 10 ? '0' + item.month : item.month
        return `${day}/${month}`
    }
}
